import React, { useContext, useState } from "react";
import MainHeader from "../headers/MainHeader";
import { styled } from "@mui/material/styles";
import ResponsiveDrawerBase from "../headers/SideBarMenu/ResponsiveDrawer";
import { Alert } from "@mui/material";
import { GlobalContext } from "@/helpers/contexts/contexts";

const drawerWidth = 240;
const ResponsiveDrawer = ResponsiveDrawerBase as React.ComponentType<any>;

type PageLayoutProps = {
  className?: string;
  containerClassName?: string;
  children?: React.ReactNode;
};

const PageStyle = styled("div")(({ theme }) => ({
  "&.root": {
    display: "flex",
  },

  "& .appBar": {
    backgroundColor: "var(--neutral-50)",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    [theme.breakpoints.up("lg")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },

  "& .toolbar": {
    ...theme.mixins.toolbar,
  },

  "& .content": {
    flexGrow: 1,
    paddingTop: "4.5rem",
  },

  "& .contentWithAlert": {
    flexGrow: 1,
    paddingTop: "calc(4.5rem + 80px)",
  },

  "& .stickyAlert": {
    position: "fixed",
    top: "4.5rem",
    zIndex: 1000,
    left: `${drawerWidth}px`,
    right: "0",
    backgroundColor: "var(--status-warning-tint)",
    border: "1px solid var(--status-warning)",
    borderRadius: "var(--radius-container)",
    margin: "12px",
    padding: "12px 16px",
    "& .MuiAlert-icon": {
      color: "var(--status-warning)",
    },
    "& .MuiAlert-message": {
      color: "var(--status-warning)",
      fontWeight: "700",
    },
    [theme.breakpoints.down("md")]: {
      left: "0",
    },
  },
}));

export default function PageLayout({
  className = "",
  containerClassName = "",
  children,
}: PageLayoutProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { selectedBrand } = useContext(GlobalContext);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <PageStyle>
      <MainHeader handleDrawerToggle={handleDrawerToggle} />

      <ResponsiveDrawer
        handleDrawerToggle={handleDrawerToggle}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
      {selectedBrand && !selectedBrand?.status && (
        <Alert severity="warning" className="stickyAlert mb-4">
          This brand is currently inactive. If you have any questions about the
          brand status, please reach out to our Customer Success team.
        </Alert>
      )}
      <div className="appBar">
        <div className="w-100">
          <main
            className={
              selectedBrand && !selectedBrand?.status
                ? "contentWithAlert"
                : "content"
            }
          >
            <div className={`page ${className}`}>
              <div className={`container-fluid ${containerClassName}`}>
                {children}
              </div>
            </div>
          </main>
        </div>
      </div>
    </PageStyle>
  );
}
